import Cookies from 'js-cookie';
import { parseDomain } from 'parse-domain';
import { useState } from 'react';
import { getCurrentLanguage } from '../utils/i18n.js';

export function useLanguage() {
    const [language, setLanguage] = useState(
        getCurrentLanguage(),
    );

    return [
        language,
        (lang) => {
            const result = parseDomain(document.location.hostname);

            Cookies.set(
                'cl',
                lang,
                {
                    domain: `.${result.domain}.${result.topLevelDomains.join('.')}`,
                    path: '/',
                    expires: 7,
                    secure: true,
                    samesite: 'None',
                },
            );

            setLanguage(lang);
        },
    ];
}
